import React, { Component, Fragment } from 'react';
import DEFINE, {PATHS, FEATURE_FLAGS} from "../../../../constants/Define";
import { Link } from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import RoomTypeList from './RoomTypeList';
import Ripple from '../../common/component/Ripple';

let permisionActions = [];
export default class RoomTypes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                hotelId: this.props.match.params.hotel_id,
                pageSize: this.props.roomTypeState.pageSize,
                pageIndex: this.props.roomTypeState.pageIndex,
            }
        };
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.ROOM_TYPE);
        this.props.getListRoomTypes(this.state.filters);
        if(this.state.filters?.hotelId){
            this.props.getHotelDetail(this.state.filters.hotelId);
        }
    }

    render() {
        const { t, match, hotelState } = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, dataList } = this.props.roomTypeState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex};

        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'roomType'}
                        titleHeader={`${t('navigation.roomTypes')} - ${hotelState?.detail?.hotel?.name || ""}`}
                        onClickBack={this.onClickBack}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate && hotelState?.detail?.hotel?.isBeachVilla &&
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Link to={Func.getPathWithParams(PATHS.ROOM_TYPE.CREATE.path, {hotel_id: match.params.hotel_id})}
                                        className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                </Ripple>
                            }
                            </Fragment>
                        }
                    />
                    <RoomTypeList
                        loading={isFetching}
                        hotelId={match.params.hotel_id}
                        permisions={permisionActions}
                        dataList={dataList}
                        pagination={pagination}
                        onChange={this.onTableChange}
                        onDeleteRoomType={this.onDeleteRoomType}
                        hotel={hotelState?.detail?.hotel}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onTableChange = (pagination, filters, sorter) => {
        let curfilters = this.state.filters;
        if (filters.status) {
            switch (filters.status[0]) {
                case 998:
                    filters = Func.removeElementObject(filters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'isExpired');
                    filters.IsLocked = true;
                    break;
                case 999:
                    filters = Func.removeElementObject(filters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'IsLocked');
                    filters.isExpired = true;
                    break;
                default:
                    if (filters.status[0] !== 998) { curfilters = Func.removeElementObject(curfilters, 'IsLocked') }
                    if (filters.status[0] !== 999) { curfilters = Func.removeElementObject(curfilters, 'isExpired') }
            }
        }
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        newFilters.hotelId = this.props.match.params.hotel_id;
        this.setState({
            filters: newFilters
        });
        this.props.getListRoomTypes(newFilters);
    };

    onDeleteRoomType = (item) => {
    }

    onClickBack = () => {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.hotel_id) {
            const path = Func.getPathWithParams(PATHS.HOTEL.DETAIL.path, { id: match.params.hotel_id })
            this.props.history.push(path);
        }
    }

    onChangeLanguage = (language) => {
        this.props.getListRoomTypes(this.state.filters)
    }
}